<app-layout-category></app-layout-category>
<p-toast></p-toast>
<p-confirmDialog [style]="{width: '50vw'}"
                 [baseZIndex]="10000"
                 [rejectVisible]="false"
                 acceptButtonStyleClass="p-button-text p-button-danger">
</p-confirmDialog>
<div class="setting-profile-user w-full h-6rem flex align-items-center">
  <span class="text-white font-semibold text-4xl username-margin" *ngIf="!isDeleted">{{profile.user_login}}</span>
  <span class="text-white font-semibold text-4xl username-margin" *ngIf="isDeleted">{{'deleted_user' | translate}}</span>
</div>
<div class="setting-profile-follow w-full h-3rem flex align-items-center">
  <div class="flex flex-row username-margin w-full">
    <div class="flex-none flex-column flex align-items-center">
      <a class="cursor-pointer text-sm"
         [ngClass]="{'text-orange-500 font-semibold' : followersSelected, 'text-white font-medium': !followersSelected}"
         [routerLink]="['/profile/' + profile.user_login + '/followers']">{{'followers'|translate}}</a>
      <span class="text-lg font-semibold" [ngClass]="{'text-orange-500' : followersSelected, 'text-white': !followersSelected}">{{profile.followerCount}}</span>
    </div>
    <div class="flex flex-none  w-2rem"></div>
    <div class="flex-none flex-column flex align-items-center">
      <a class="cursor-pointer text-sm"
         [ngClass]="{'text-orange-500 font-semibold' : followingSelected, 'text-white font-medium': !followingSelected}"
         [routerLink]="['/profile/' + profile.user_login + '/following']">{{'following'|translate}}</a>
      <span class="text-lg font-semibold" [ngClass]="{'text-orange-500' : followingSelected, 'text-white': !followingSelected}">{{profile.followingCount}}</span>
    </div>
    <div class="flex flex-grow-1"></div>
    <div class="flex-none flex-column flex justify-content-center">
      <p-button *ngIf="!isUser && profile.isFollowing"
                (onClick)="unfollow()"
                label="{{'unfollow'|translate}}"
                icon="pi pi-user-minus"
                class="mr-2"
                styleClass="hidden md:block p-button-sm p-button-orange font-semibold"></p-button>
      <p-button *ngIf="!isUser && !profile.isFollowing"
                (onClick)="follow()"
                label="{{'follow'|translate}}"
                icon="pi pi-user-plus"
                class="mr-2"
                styleClass="hidden md:block p-button-sm p-button-orange font-semibold"></p-button>
    </div>
  </div>
</div>
<div class="flex flex-column w-full bg-white h-full md:flex-row">
  <div class="setting-profile-left-panel w-full md:w-22rem flex-column flex">
    <span class="ml-3 md:ml-0 md:text-center w-full inline-block">
            <i class="avatar-overlay border-circle profile-avatar-picture h-12rem" *ngIf="isUser">
                  <p-fileUpload #fileUpload
                                class="h-full flex justify-content-center align-items-end"
                                name="myfile[]"
                                mode="basic"
                                [customUpload]="true"
                                (onSelect)="changeAvatar($event, fileUpload)"
                                [auto]="true"
                                accept="image/*"
                                chooseIcon="pi pi-pencil"
                                styleClass="p-button-dlnd-dark mb-2">
                  </p-fileUpload>
            </i>
      <img class="border-circle profile-avatar-picture h-12rem" src="{{avatarUrl}}" appImgFallback='{{fallbackImg}}'/>
          <p-button *ngIf="!isUser && profile.isFollowing"
                    (onClick)="unfollow()"
                    label="{{'unfollow'|translate}}"
                    icon="pi pi-user-minus"
                    styleClass="md:hidden p-button-sm p-button-orange font-semibold mt-2 mr-4"
                    style="float: right"></p-button>
          <p-button *ngIf="!isUser && !profile.isFollowing"
                    (onClick)="follow()"
                    label="{{'follow'|translate}}"
                    icon="pi pi-user-plus"
                    styleClass="md:hidden p-button-sm p-button-orange font-semibold mt-2 mr-4"
                    style="float: right"></p-button>
    </span>
    <div class="flex flex-column align-items-start md:align-items-end ml-3 md:mr-3 md:ml-0 ">
      <a *ngIf="!isUser"
         class="cursor-pointer mt-5"
         [ngClass]="{'text-900 font-semibold' : personalInfoSelected, 'text-white font-medium': !personalInfoSelected}"
         [routerLink]="['/profile/' + profile.user_login]">{{'information'|translate}}</a>
      <a *ngIf="isUser"
         class="cursor-pointer mt-5"
         [ngClass]="{'text-900 font-semibold' : personalInfoSelected, 'text-white font-medium': !personalInfoSelected}"
         [routerLink]="['/profile/' + profile.user_login]">{{'personal_info'|translate}}</a>
      <a class="cursor-pointer mt-5"
         [ngClass]="{'text-900 font-semibold' : pubDealsSelected, 'text-white font-medium': !pubDealsSelected, 'mb-8': !isUser && !isAdmin}"
         [routerLink]="['/profile/' + profile.user_login + '/deals']">{{'published_deals'|translate}}</a>
      <a *ngIf="isUser && false"
         class="cursor-pointer mt-5"
         [ngClass]="{'text-900 font-semibold' : commentsSelected, 'text-white font-medium': !commentsSelected}"
         [routerLink]="['/profile/' + profile.user_login + '/comments']">{{'comments'|translate}}</a>
      <a *ngIf="isUser"
         class="cursor-pointer mt-5"
         [ngClass]="{'text-900 font-semibold' : filtersNotificationSelected, 'text-white font-medium': !filtersNotificationSelected, 'mb-8': !isUser}"
         [routerLink]="['/profile/' + profile.user_login + '/notifications']">{{'filters_notifications_menu'|translate}}</a>
      <a *ngIf="isUser || isAdmin"
         class="cursor-pointer mt-5"
         [ngClass]="{'text-900 font-semibold' : settingsSelected, 'text-white font-medium': !settingsSelected, 'mb-8': !isUser && isAdmin}"
         [routerLink]="['/profile/' + profile.user_login + '/settings']">{{'settings'|translate}}</a>
      <hr *ngIf="isUser" class="w-full"/>
      <a *ngIf="isUser" class="text-orange-900 font-medium cursor-pointer mt-5 mb-3" (click)="logout()">{{'logout'|translate}}</a>
    </div>
  </div>
  <div class="w-full p-3" *ngIf="personalInfoSelected">
    <div class="px-3 pb-3">
      <app-profile-stats [profile]="profile"></app-profile-stats>
    </div>
    <div class="px-3 pb-3" *ngIf="isUser">
      <header>
        <h3>{{'personal_details'|translate}}</h3>
      </header>
      <div class="px-5">
        <div class="grid p-fluid">
          <div class="col-12">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon"><i class="pi pi-envelope"></i></span>
              <input type="email" disabled [(ngModel)]="user.email" pInputText placeholder="{{'email'|translate}}">
            </div>
          </div>
          <div class="col-12">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon"><i class="icon-contact"></i></span>
              <input type="text" [(ngModel)]="user.names" pInputText placeholder="{{'real_name'|translate}}">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="px-3 pb-3" *ngIf="profile.user_facebook != undefined || profile.user_instagram != undefined || profile.user_twitter != undefined || isUser">
      <header>
        <h3>{{'social_accounts'|translate}}</h3>
      </header>
      <div class="px-5">
        <div class="grid p-fluid">
          <div class="col-12"  *ngIf="profile.user_facebook != undefined || isUser">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon"><i class="pi pi-facebook"></i></span>
              <input type="text" pInputText placeholder="Facebook" [(ngModel)]="profile.user_facebook" [disabled]="!isUser">
            </div>
          </div>
          <div class="col-12"  *ngIf="profile.user_twitter != undefined || isUser">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon"><i class="pi pi-twitter"></i></span>
              <input type="text" pInputText placeholder="Twitter" [(ngModel)]="profile.user_twitter" [disabled]="!isUser">
            </div>
          </div>
          <div class="col-12"  *ngIf="profile.user_instagram != undefined || isUser">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon"><i class="pi pi-instagram"></i></span>
              <input type="text" pInputText placeholder="Instagram" [(ngModel)]="profile.user_instagram" [disabled]="!isUser">
            </div>
          </div>
        </div>
        <button pButton label="{{'edit_personal_information_btn' | translate}}"
                *ngIf="isUser"
                (click)="editPersonalInformation()"
                [loading]="updatingInformation"
                class="p-button-raised p-button-dlnd col-12 md:col-4 mt-2 md:col-offset-8"></button>
      </div>
    </div>
  </div>
  <div class="w-full p-3" *ngIf="pubDealsSelected">
    <app-deal-list [limit]="12"
                   [config]="listConfig"
                   [profileList]="true"></app-deal-list>
  </div>
  <div class="w-full p-3" *ngIf="filtersNotificationSelected">
    <app-notification-settings></app-notification-settings>
  </div>
  <div class="w-full p-3" *ngIf="followersSelected">
    <div *ngIf="profile.followerCount > 0">
      <div *ngFor="let follower of followers">
        <a href="{{'profile_url'| translate}}/{{ follower.user_login }}"><img class="border-circle p-1 h-4rem w-4rem mr-2" src="{{getFollowAvatar(follower.user_id)}}" appImgFallback='{{fallbackImg}}'/>{{ follower.user_login }}</a>
      </div>
    </div>
    <div *ngIf="profile.followerCount === 0">
      <p>{{'no_followers_for' | translate}} {{ profile.user_login }}</p>
    </div>
  </div>
  <div class="w-full p-3" *ngIf="followingSelected">
    <div *ngIf="profile.followingCount > 0">
      <div *ngFor="let follow of following">
        <a href="{{'profile_url'| translate}}/{{ follow.user_login }}"><img class="border-circle p-1 h-4rem w-4rem mr-2" src="{{getFollowAvatar(follow.user_id)}}" appImgFallback='{{fallbackImg}}'/>{{ follow.user_login }}</a>
      </div>
    </div>
    <div *ngIf="profile.followingCount === 0">
      <p>{{ profile.user_login }} {{'no_following_for' | translate}}</p>
    </div>
  </div>
  <div class="w-full p-3" *ngIf="settingsSelected && (isUser || isAdmin)">
    <header *ngIf="isUser">
      <h3>{{'change_password'|translate}}</h3>
    </header>
    <div class="px-5" *ngIf="isUser">
      <form  [formGroup]="authForm" (ngSubmit)="submitPasswordForm()">
        <div class="formgrid grid p-fluid">
          <div class="field col-12">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon"><i class="pi pi-lock-open"></i></span>
              <input type="password"
                     formControlName="currentPassword"
                     id="currentPassword"
                     autocomplete="current-password"
                     pInputText placeholder="{{'current_password'|translate}}">
            </div>
            <small class="p-error block" *ngIf="isSubmitting && f?.currentPassword?.errors?.required != undefined">{{'password_required' | translate}}</small>
            <small class="p-error block" *ngIf="(serverErrorId === 2)">{{'password_not_valid' | translate}}</small>
          </div>
          <div class="field col-12">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon"><i class="pi pi-lock"></i></span>
              <input type="password"
                     formControlName="newPassword"
                     id="newPassword"
                     autocomplete="new-password"
                     pInputText placeholder="{{'new_password'|translate}}">
            </div>
            <small class="p-error block" *ngIf="isSubmitting && f?.newPassword?.errors?.required != undefined">{{'password_required' | translate}}</small>
          </div>
          <div class="field col-12">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon"><i class="pi pi-lock"></i></span>
              <input type="password"
                     formControlName="newPasswordConfirm"
                     id="newPasswordConfirm"
                     autocomplete="new-password"
                     pInputText placeholder="{{'verify_new_password'|translate}}">
            </div>
            <small class="p-error block" *ngIf="isSubmitting && f?.newPasswordConfirm?.errors?.required != undefined">{{'verify_password_required' | translate}}</small>
            <small class="p-error block" *ngIf="isSubmitting && f?.newPasswordConfirm?.errors?.mustMatch != undefined">{{'passwords_not_match' | translate}}</small>
          </div>
        </div>
        <button pButton label="{{'change_password' | translate}}"
                type="submit"
                class="p-button-raised p-button-dlnd col-12 md:col-4 md:col-offset-8"></button>
      </form>
    </div>
    <header *ngIf="isAdmin">
      <h3>{{'delete_account'|translate}}</h3>
    </header>
    <button pButton label="{{'delete_my_account' | translate}}"
            (click)="deletePressed()"
            class="p-button-raised p-button-dlnd-dark p-button-sm"></button>
  </div>
</div>
